import PropTypes from 'prop-types';
import 'intersection-observer';
import { useInView } from 'react-intersection-observer';

const LazyLoadedImage = ({ width, height, alt, src, classes, className, onLoad, onError, ...rest }) => {
  const [ref, inView] = useInView({
    triggerOnce: true
  });

  return (
    <span
      style={{ display: 'block' }}
      ref={ref}
      className={className}
    >
      {inView ? (
        <img
          {...rest}
          src={src}
          width={width}
          height={height}
          alt={alt}
          onLoad={onLoad}
          onError={onError}
          className={classes}
        />
      ) : null}
    </span>
  );
};

export default LazyLoadedImage;

LazyLoadedImage.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
  classes: PropTypes.string,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func
};

LazyLoadedImage.defaultProps = {
  width: undefined,
  height: undefined,
  alt: undefined,
  src: undefined,
  classes: undefined,
  className: undefined,
  onLoad: () => {},
  onError: () => {}
};
